import React from "react"

import {
    DataGrid,
    GridPaginationModel,
    GridSortModel,
} from "@mui/x-data-grid"

import {
    ContractListItem,
    OrderType, PaginationInfo,
    SearchFilter,
} from "models"
import { PaginationActions } from "components/commons"

import getContractTableColumns, {ContractTableInterface} from "./contract-table-columns"

interface ContractTableProps
{
    handleCallback: (data: SearchFilter) => void
    openModal: (contractId: string) => void
    openDelete: (contractId: string) => void
    data: ContractListItem[] | null
    pagination: PaginationInfo
}
interface ContractTableState
{
    pagination: SearchFilter
}
export class ContractTable extends React.Component<ContractTableProps, ContractTableState> implements ContractTableInterface
{
    private readonly columns: any

    constructor(props: ContractTableProps)
    {
        super(props)
        this.columns = getContractTableColumns(this)
        this.state = {
            pagination: {
                pageSize: 10,
                pageId: 0,
                orderBy: null,
                orderType: null
            },
        }
    }

    private handlePagination = (model: GridPaginationModel) => {
        if(this.state.pagination.pageSize !== model.pageSize || this.state.pagination.pageId !== model.page){
            this.setState(
                () => ({
                    pagination: {
                        ...this.state.pagination,
                        pageSize: model.pageSize,
                        pageId: model.page,
                    },
                }),
                () => this.props.handleCallback(this.state.pagination as any)
            )
        }
    }

    private handleSorting = (model: GridSortModel) => {

        if(model.length !== 0) {
            let orderType: string | null
            if(model[0].sort === "asc") {
                orderType = OrderType.ASCENDING
            } else if(model[0].sort === "desc") {
                orderType = OrderType.DESCENDING
            } else {
                orderType = null
            }

            if(this.state.pagination.orderBy !== model[0].field || this.state.pagination.orderType !== orderType){
                this.setState(() => ({
                    pagination: {
                        pageSize: this.state.pagination.pageSize,
                        pageId: this.state.pagination.pageId,
                        orderBy: model[0].field,
                        orderType: orderType,
                    } as SearchFilter,
                }), () => this.props.handleCallback(this.state.pagination as any))
            }
        }
    }

    public deleteContract = (contractId: string) => {
        this.props.openDelete(contractId)
    }

    public openModal = (contractId: string) => {
        this.props.openModal(contractId)
    }

    render()
    {
        const rows: object[] = []

        if(this.props.data !== null) {
            let i

            for(i = 0; i < this.props.data.length; i++) {
                let row = {
                    id: this.props.data[i].id,
                    contractNumber:  this.props.data[i].contractNumber,
                    status: this.props.data[i].status,
                    brand: this.props.data[i].brandName,
                    asset: this.props.data[i].assetAddress,
                    startDate: this.props.data[i].startDate,
                    endDate: this.props.data[i].endDate,
                    signDate: this.props.data[i].signDate,

                }
                rows.push(row)
            }
        }

        // FIXME: replace DataGrid with SbPaginatedDatagrid
        return (
            <DataGrid
                rows={rows}
                columns={this.columns}
                autoHeight
                pagination
                paginationMode="server"
                paginationModel={{ page: this.props.pagination.currentPage || 0, pageSize: this.state.pagination.pageSize }}
                onPaginationModelChange={this.handlePagination}
                rowCount={this.props.pagination.totalRecords || 0}
                pageSizeOptions={[10, 15, 20]}
                sortingMode="server"
                onSortModelChange={this.handleSorting}
                slotProps={{
                    pagination: {
                        ActionsComponent: PaginationActions
                    }
                }}
                disableRowSelectionOnClick
                disableColumnMenu={true}
                sx={{
                    bgcolor: "background.default",
                    '& .MuiDataGrid-cell:focus': {
                        outline: "none"
                    }
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "id", sort: "asc" }],
                    },
                }}
            />
        )
    }
}
